var e = "YY-MM-DD HH:MM",
  E = "Enter date time",
  s = "00-00-00 00:00".split("").map(function (t) {
    return /\d/.test(t) ? Number(t) : t;
  });
export { E as DEFAULT_PLACEHOLDER, s as MASK, e as PLACEHOLDER };